import Nullstack from 'nullstack';
export default function IconBorderLeft({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-border-left",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("line", {
    x1: "4",
    y1: "20",
    x2: "4",
    y2: "4"
  }), "   ", Nullstack.element("line", {
    x1: "8",
    y1: "4",
    x2: "8",
    y2: "4.01"
  }), "   ", Nullstack.element("line", {
    x1: "12",
    y1: "4",
    x2: "12",
    y2: "4.01"
  }), "   ", Nullstack.element("line", {
    x1: "16",
    y1: "4",
    x2: "16",
    y2: "4.01"
  }), "   ", Nullstack.element("line", {
    x1: "20",
    y1: "4",
    x2: "20",
    y2: "4.01"
  }), "   ", Nullstack.element("line", {
    x1: "12",
    y1: "8",
    x2: "12",
    y2: "8.01"
  }), "   ", Nullstack.element("line", {
    x1: "20",
    y1: "8",
    x2: "20",
    y2: "8.01"
  }), "   ", Nullstack.element("line", {
    x1: "8",
    y1: "12",
    x2: "8",
    y2: "12.01"
  }), "   ", Nullstack.element("line", {
    x1: "12",
    y1: "12",
    x2: "12",
    y2: "12.01"
  }), "   ", Nullstack.element("line", {
    x1: "16",
    y1: "12",
    x2: "16",
    y2: "12.01"
  }), "   ", Nullstack.element("line", {
    x1: "20",
    y1: "12",
    x2: "20",
    y2: "12.01"
  }), "   ", Nullstack.element("line", {
    x1: "12",
    y1: "16",
    x2: "12",
    y2: "16.01"
  }), "   ", Nullstack.element("line", {
    x1: "20",
    y1: "16",
    x2: "20",
    y2: "16.01"
  }), "   ", Nullstack.element("line", {
    x1: "8",
    y1: "20",
    x2: "8",
    y2: "20.01"
  }), "   ", Nullstack.element("line", {
    x1: "12",
    y1: "20",
    x2: "12",
    y2: "20.01"
  }), "   ", Nullstack.element("line", {
    x1: "16",
    y1: "20",
    x2: "16",
    y2: "20.01"
  }), "   ", Nullstack.element("line", {
    x1: "20",
    y1: "20",
    x2: "20",
    y2: "20.01"
  }), " ");
}